import { render, staticRenderFns } from "./GetOffersOffer.vue?vue&type=template&id=8bcf27ea&"
import script from "./GetOffersOffer.vue?vue&type=script&lang=js&"
export * from "./GetOffersOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports